import { useSearchParams as useSearchParamsReactRouter } from "react-router-dom";

export const useSearchParams = (key: string) => {
  const [searchParams] = useSearchParamsReactRouter();
  return searchParams.get(key);
};

export const useSetSearchParams = () => {
  const [, setSearchParams] = useSearchParamsReactRouter();
  return setSearchParams;
};
